import { BaseError } from './base-error';

export class BusinessException extends BaseError {
    constructor(public status: number, public message: string) {
        super();
    }
}
